import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-caps-lock-modal',
  templateUrl: './caps-lock-modal.component.html',
  styleUrls: ['./caps-lock-modal.component.scss']
})
export class CapsLockModalComponent {
  private route: ActivatedRoute;
  constructor(
    public bsModalRef: BsModalRef,
    private router: Router
  ) { }

  back(): void {
    this.bsModalRef.hide();
    this.router.navigate(['..'], {relativeTo: this.route});
  }
}
